/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import LicensingPage from "./LicensingPage";
import GenericButton from "@ui-components/Button/GenericButton";
import AddLicenseModalV1 from "./AddLicenseModalV1";
import GenericAlert from "@ui-components/Alert/GenericAlert";

interface LicenseTableItem {
  id: number;
  serial: string;
  description: string;
  type: string;
  startdate: string;
  enddate: string;
  activated: number;
  total: number;
  tenant: number;
}

const AdminCenterLicensingPage: React.FC = () => {
  const [isAddLicenseModalOpen, setIsAddLicenseModalOpen] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [prefillLicense, setPrefillLicense] = useState<LicenseTableItem | null>(null);

  const handleAddLicense = () => {
    setPrefillLicense(null);
    setIsAddLicenseModalOpen(true);
  };

  const handleEditLicense = (license: LicenseTableItem) => {
    setPrefillLicense(license);
    setIsAddLicenseModalOpen(true);
  };

  const handleCreateOrUpdateLicense = () => {
    const wasEdit = !!prefillLicense;
    setIsAddLicenseModalOpen(false);
    // Show success alert
    setAlertMessage(wasEdit ? "License updated successfully!" : "License created successfully!");
    setIsAlertOpen(true);
    // Trigger refresh by incrementing refreshTrigger
    setRefreshTrigger(prev => prev + 1);
    setPrefillLicense(null);
  };

  return (
    <div className="relative">
      {/* Add License Button for Admin Center */}
      <div className="flex justify-end p-4 mb-4">
        <GenericButton
          label="Add License"
          variant="brand"
          size="md"
          onClick={handleAddLicense}
        />
      </div>
      {/* Render the v1 Licensing Page */}
      <LicensingPage refreshTrigger={refreshTrigger} onEditLicense={handleEditLicense} />
      <AddLicenseModalV1
        isOpen={isAddLicenseModalOpen}
        onClose={() => {
          setIsAddLicenseModalOpen(false);
          setPrefillLicense(null);
        }}
        onCreate={handleCreateOrUpdateLicense}
        prefill={prefillLicense ? {
          id: prefillLicense.id,
          tenantId: prefillLicense.tenant,
          serial: prefillLicense.serial,
          description: prefillLicense.description,
          type: prefillLicense.type,
          startdate: prefillLicense.startdate,
          enddate: prefillLicense.enddate,
          total: prefillLicense.total,
          activated: prefillLicense.activated,
        } : null}
      />
      <GenericAlert
        isOpen={isAlertOpen}
        onClose={() => setIsAlertOpen(false)}
        onConfirm={() => setIsAlertOpen(false)}
        title={alertMessage.includes("updated") ? "License Updated Successfully" : "License Created Successfully"}
        description={alertMessage}
        cancelLabel="Close"
        confirmLabel="OK"
        variant="success"
      />
    </div>
  );
};

export default AdminCenterLicensingPage;
